export enum FallbackModeType {
  ElectronicFallback = 'ELECTRONIC_FALLBACK',
}